export const formatDate = (dateString: string) => {
	const date = new Date(dateString)
	return date
		.toLocaleDateString('en-US', {
			month: '2-digit',
			day: '2-digit',
			year: 'numeric',
			timeZone: 'UTC',
		})
		.replace(/\//g, '.')
}
